import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Typography, Button, Box, Paper, Divider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useDeepCompareEffect } from "@fuse/hooks";
import { getReportById, selectReportById } from "../../reports/store/reportSlice";
import FuseLoading from "@fuse/core/FuseLoading";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";

const ViewReportHoteliers = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const [answersByCategory, setAnswersByCategory] = useState([]);
  const [page, setPage] = useState(0);

  const { reportId } = params;
  const report = useSelector((state) => selectReportById(state, reportId));

  useEffect(() => {
    if (report) {
      // Agrupar por question_name
      const grouped = report.answers
        .filter((item) => item.question_name.trim() !== "HOSPEDAJE TALTAL")
        .reduce((acc, item) => {
          const category = item.question_name.trim();

          if (!acc[category]) acc[category] = [];
          acc[category].push(item);
          return acc;
        }, {});

      const groupedArray = Object.entries(grouped).map(([category, items]) => ({
        category,
        items,
      }));

      setAnswersByCategory(groupedArray);
    }
  }, [report]);

  useDeepCompareEffect(() => {
    dispatch(getReportById(reportId));
  }, [dispatch]);

  if (!report) return <FuseLoading />;

  const currentCategory = answersByCategory[page] || null;
  const handleBack = () => history.back();

  return (
    <Box p={3}>
      <Button
        style={{ marginBottom: 10 }}
        variant="contained"
        color="info"
        onClick={handleBack}
        size="small"
        startIcon={
          <FuseSvgIcon size={20}>material-solid:arrow_back</FuseSvgIcon>
        }
      >
        Volver
      </Button>

      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "primary.main" }}
      >
        {report.name}: {report.code}
      </Typography>
      <Typography align="center" variant="subtitle1" gutterBottom>
        Realizada por <strong>{report.user_name}</strong>
      </Typography>

      {/* <Button
        variant="outlined"
        size="small"
        color="primary"
        onClick={() => exportImagesReport(report, answersByCategory)}
      >
        Exportar PDF
      </Button> */}

      {currentCategory && (
        <Paper elevation={3} sx={{ p: 4, mt: 3, borderRadius: 3 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", color: "primary.main", mb: 3 }}
          >
            {currentCategory.category}
          </Typography>

          {currentCategory.items.map((item, i) => (
            <Box key={item.id} sx={{ mb: 4 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bold", mb: 1 }}
              >
                Punto {i + 1}: {item.name}
              </Typography>

              {item.question_type === "photo" && item.image_url ? (
                <Box sx={{ textAlign: "center", mb: 2 }}>
                  <img
                    src={item.image_url}
                    alt={item.name || "Foto"}
                    style={{
                      maxWidth: 400,
                      width: "100%",
                      height: "auto",
                      borderRadius: 10,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      const img = e.target;
                      img.style.transform =
                        img.style.transform === "scale(1.5)"
                          ? "scale(1)"
                          : "scale(1.5)";
                      img.style.transition = "transform 0.2s ease-in-out";
                    }}
                  />
                </Box>
              ) : (
                <Typography variant="body1" sx={{ ml: 1 }}>
                  {item.question_value}
                </Typography>
              )}
              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}

          <Box mt={4} display="flex" justifyContent="center" gap={2}>
            <Button
              variant="outlined"
              color="secondary"
              disabled={page === 0}
              onClick={() => setPage((p) => p - 1)}
            >
              Anterior
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={page === answersByCategory.length - 1}
              onClick={() => setPage((p) => p + 1)}
            >
              Siguiente
            </Button>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default ViewReportHoteliers;
